export default "__VITE_ASSET__XkaIAC2E__"